export default __webpack_public_path__ + "static/media/bg-map.bd8eeac3.png";